import React, { FunctionComponent } from 'react';
import { IInPageAnchorWidget } from '../../../../models/campaign-pages/widgets/in-page-anchor/in-page-anchor.model';

export type InPageAnchorProps = {
  inPageAnchor: IInPageAnchorWidget;
};

/** https://rs-components.atlassian.net/browse/EMD-972 */
export const InPageAnchor: FunctionComponent<InPageAnchorProps> = (props: InPageAnchorProps) => {
  return <div id={props.inPageAnchor.anchorId}></div>;
};

export default InPageAnchor;
